import { Model } from "pinia-orm";
export default class User extends Model {
  static name = "User";
  static entity = "users";
  static primaryKey = "email";

  static fields() {
    return {
      uuid: this.uid(""),
      cloudId: this.attr(null),
      email: this.string(""),
      firstName: this.attr(""),
      groups: this.attr([]),
      isSuperUser: this.boolean(false),
      isCurrentUser: this.boolean(false),
      jobTitle: this.string(""),
      lastName: this.attr(""),
      telephoneNumber: this.attr(""),
      socotecCode: this.string(""),
      agency: this.uid(""),
      agencyGroup: this.uid(""),
      society: this.uid(""),
      businessUnit: this.uid(""),
      usermanagementUuid: this.uid(""),
    };
  }
}
